<template>
  <generic-modal
    :title="$t('personal savings account request')"
    ref="generic_modal"
    @close-modal="set_initial_state"
    size="fullscreen"
  >
    <form>
      <!-- Selection Section -->
      <div class="box mb-5">
        <div class="columns">
          <!-- Destinatary Selection -->
          <div class="column is-two-fifths">
            <div class="field">
              <generic-dropdown
                :title="$t('destinatary')"
                :placeholder="$t('select one')"
                :is_multiple="false"
                url="/account-request/destinatary/catalog"
                name_field="name"
                value_field="destinatary_id"
                @selected="destinatary_changed"
                :add_new="true"
                @add_new="add_destinatary"
                ref="destinatary_dropdown"
              />
            </div>

            <!-- Destinatary Information Display -->
            <div v-if="selected_destinatary" class="box has-background-dark">
              <!-- <h6 class="title is-6 mb-3">
                <span class="icon">
                  <i class="fa fa-user"></i>
                </span>
                {{ $t("destinatary information") }}
              </h6> -->

              <div class="content">
                <div class="field mb-2">
                  <!-- <label class="label is-small">{{ $t("full name") }}</label> -->
                  <p class="is-size-6">
                    <span class="icon is-small">
                      <i class="fa fa-user"></i>
                    </span>
                    {{ selected_destinatary.name }}
                    <!-- <span
                      class="tag is-warning is-small ml-2"
                      v-if="selected_destinatary.destinatary_type?.name"
                    >
                      {{ selected_destinatary.destinatary_type?.name }}
                    </span> -->
                  </p>
                </div>

                <div class="field mb-2">
                  <!-- <label class="label is-small">{{
                    $t("identification")
                  }}</label> -->
                  <p class="is-size-6">
                    <span class="icon is-small">
                      <i class="fa fa-id-card"></i>
                    </span>
                    {{ selected_destinatary.dpi }}
                  </p>
                </div>

                <div class="field mb-2">
                  <!-- <label class="label is-small">{{ $t("email") }}</label> -->
                  <p class="is-size-6">
                    <span class="icon is-small">
                      <i class="fa fa-envelope"></i>
                    </span>
                    {{ selected_destinatary.email }}
                  </p>
                </div>

                <div class="field mb-0">
                  <!-- <label class="label is-small">{{ $t("phone") }}</label> -->
                  <p class="is-size-6">
                    <span class="icon is-small">
                      <i class="fa fa-phone"></i>
                    </span>
                    {{ selected_destinatary.phone }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Empty State for Destinatary -->
            <div v-else class="notification is-info">
              <span class="icon">
                <i class="fa fa-info-circle"></i>
              </span>
              {{ $t("select a destinatary") }}
            </div>
          </div>

          <!-- Entity Selection -->
          <div class="column">
            <div class="field">
              <generic-dropdown
                :title="$t('entity')"
                :placeholder="$t('select one')"
                :is_multiple="false"
                url="/account-request/entity/catalog"
                name_field="name"
                value_field="entity_id"
                @selected="entity_changed"
                ref="entity_dropdown"
              />
            </div>

            <!-- Entity Information Display -->
            <div v-if="selected_entity" class="box has-background-dark">
              <!-- <h6 class="title is-6 mb-3">
                <span class="icon">
                  <i class="fa fa-building"></i>
                </span>
                {{ $t("entity information") }}
              </h6> -->

              <div class="content">
                <div class="field mb-0">
                  <!-- <label class="label is-small">{{ $t("entity name") }}</label> -->
                  <p class="is-size-6">
                    <span class="icon is-small">
                      <i class="fa fa-building"></i>
                    </span>
                    {{ selected_entity.name }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Empty State for Entity -->
            <div v-else class="notification is-info">
              <span class="icon">
                <i class="fa fa-info-circle"></i>
              </span>
              {{ $t("select an entity") }}
            </div>
          </div>

          <div class="column">
            <div class="field">
              <generic-dropdown
                :title="$t('product')"
                :placeholder="$t('select one')"
                :is_multiple="false"
                url="/account-request/product/catalog"
                name_field="name"
                value_field="product_id"
                @selected="product_changed"
                ref="product_dropdown"
              />
            </div>

            <!-- Entity Information Display -->
            <div v-if="selected_product" class="box has-background-dark">
              <!-- <h6 class="title is-6 mb-3">
                <span class="icon">
                  <i class="fa fa-building"></i>
                </span>
                {{ $t("entity information") }}
              </h6> -->

              <div class="content">
                <div class="field mb-0">
                  <!-- <label class="label is-small">{{ $t("entity name") }}</label> -->
                  <p class="is-size-6">
                    <span class="icon is-small">
                      <i class="fa fa-cubes"></i>
                    </span>
                    {{ selected_product.name }}
                  </p>
                  <div class="title is-6">{{ $t("documentation") }}</div>
                  <div v-if="meta.settings?.documentation?.length">
                    <div
                      class="field"
                      v-for="(doc, index) in meta.settings.documentation"
                      :key="index"
                    >
                      <input
                        class="is-checkradio"
                        type="checkbox"
                        :id="'chk_document_' + index"
                        v-model="meta.settings.documentation[index].is_required"
                      />
                      <label :for="'chk_document_' + index">
                        {{ doc.name }}
                      </label>
                    </div>
                  </div>
                  <div v-else>
                    <em>{{ $t("no documentation required") }}</em>
                    <br />
                  </div>
                </div>
              </div>
            </div>

            <!-- Empty State for Entity -->
            <div v-else class="notification is-info">
              <span class="icon">
                <i class="fa fa-info-circle"></i>
              </span>
              {{ $t("select a product") }}
            </div>
          </div>
        </div>
      </div>

      <!-- Request Options Section -->
      <div v-if="meta.settings" class="box">
        <h5 class="title is-5 mb-4">
          <span class="icon">
            <i class="fa fa-cogs"></i>
          </span>
          {{ $t("request options") }}
        </h5>

        <!-- Communication Options -->
        <div class="field">
          <h6 class="title is-6 mb-3">
            <span class="icon">
              <i class="fa fa-comments"></i>
            </span>
            {{ $t("communication methods") }}
          </h6>

          <div class="columns">
            <div class="column">
              <div class="field">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_send_email"
                  name="chk_send_email"
                  v-model="meta.settings.send_email"
                />
                <label for="chk_send_email">
                  <span class="icon is-small">
                    <i class="fa fa-envelope"></i>
                  </span>
                  {{ $t("send email") }}
                </label>
              </div>
            </div>

            <div class="column">
              <div class="field">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_send_sms"
                  name="chk_send_sms"
                  v-model="meta.settings.send_sms"
                />
                <label for="chk_send_sms">
                  <span class="icon is-small">
                    <i class="fa fa-phone"></i>
                  </span>
                  {{ $t("send sms") }}
                </label>
              </div>
            </div>

            <div class="column">
              <div class="field">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_send_whatsapp"
                  name="chk_send_whatsapp"
                  v-model="meta.settings.send_whatsapp"
                />
                <label for="chk_send_whatsapp">
                  <span class="icon is-small">
                    <i class="fa fa-whatsapp"></i>
                  </span>
                  {{ $t("send whatsapp") }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- Verification Options -->
        <div class="field">
          <div class="title is-6 mb-3">
            <span class="icon">
              <i class="fa fa-arrow-right"></i>
            </span>
            {{ $t("flow options") }}
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label" style="font-weight: unset">
                  <span class="icon is-small">
                    <i class="fa fa-lock"></i>
                  </span>
                  {{ $t("security method") }}
                </label>
                <div class="control">
                  <div class="select is-fullwidth">
                    <select v-model="meta.settings.security_method">
                      <option value="none">{{ $t("none") }}</option>
                      <option value="sms-code">{{ $t("sms code") }}</option>
                      <option value="email-code">{{ $t("email code") }}</option>
                      <option value="whatsapp-code">
                        {{ $t("whatsapp code") }}
                      </option>
                      <option value="dpi">{{ $t("dpi") }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="column">
              <div class="field">
                <label class="label" style="font-weight: unset">
                  <span class="icon is-small">
                    <i class="fa fa-arrow-right"></i>
                  </span>
                  {{ $t("flow") }}
                </label>
                <div class="control">
                  <div class="select is-fullwidth">
                    <select v-model="meta.settings.flow">
                      <option value="capture-verification-documentation">
                        {{ $t("capture-verification-documentation") }}
                      </option>
                      <option value="capture-documentation-verification">
                        {{ $t("capture-documentation-verification") }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="column">
              <label for="">&nbsp;</label>
              <div class="field">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_run_onfido"
                  name="chk_run_onfido"
                  v-model="meta.settings.run_onfido"
                />
                <label for="chk_run_onfido">
                  <span class="icon is-small">
                    <i class="fa fa-id-badge"></i>
                  </span>
                  {{ $t("run onfido") }}
                </label>
              </div>
            </div>

            <!-- <div class="column">
              <div class="field">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_reproduce_video"
                  name="chk_reproduce_video"
                  v-model="meta.settings.reproduce_video"
                />
                <label for="chk_reproduce_video">
                  <span class="icon is-small">
                    <i class="fa fa-play"></i>
                  </span>
                  {{ $t("reproduce video") }}
                </label>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </form>

    <!-- Error Notification -->
    <div class="notification is-danger mt-5" v-if="error">
      <button class="delete" @click="error = ''"></button>
      <div v-html="error"></div>
    </div>

    <!-- Modal Footer -->
    <template v-slot:footer>
      <button
        class="button is-success"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button" @click="close_modal">
        <span class="icon">
          <i class="fa fa-times"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>

    <!-- Child Modals -->
    <destinatary-modal ref="destinatary_modal" />
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import { post, put, get, success_message, error_message } from "@/utils";
import DestinataryModal from "../../destinataries_datatable/destinatary_modal/Index.vue";

export default {
  name: "PersonalSavingsRequestModal",
  components: { GenericModal, GenericDropdown, DestinataryModal },
  data() {
    return {
      meta: {
        destinatary_id: null,
        entity_id: null,
        product_id: null,
        settings: {
          send_email: true,
          send_sms: false,
          send_whatsapp: false,
          run_onfido: false,
          reproduce_video: false,
          security_method: "none",
          documentation: [],
        },
      },
      error: "",
      selected_destinatary: null,
      selected_entity: null,
      selected_product: null,
    };
  },
  computed: {
    is_form_invalid() {
      return (
        !this.meta.destinatary_id ||
        !this.meta.entity_id ||
        !this.meta.product_id
      );
    },
  },
  methods: {
    show_modal(uuid = null) {
      let v = this;
      v.meta.uuid = uuid;
      v.$refs.generic_modal.show_modal();
      if (uuid) {
        v.get_entity(uuid);
      }
    },
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    set_initial_state() {
      this.meta = {
        destinatary_id: null,
        entity_id: null,
        product_id: null,
        settings: {
          send_email: true,
          send_sms: false,
          send_whatsapp: false,
          run_onfido: false,
          reproduce_video: false,
          security_method: "none",
        },
      };
      this.error = "";
      this.selected_destinatary = null;
      this.selected_entity = null;
      this.$refs.destinatary_dropdown.clear();
      this.$refs.entity_dropdown.clear();
      this.$refs.product_dropdown.clear();
    },
    get_entity(uuid) {
      let v = this;
      get("/account-request/personal-savings", { uuid: uuid })
        .then((response) => {
          v.meta = response;

          if (response.destinatary_id) {
            v.$refs.destinatary_dropdown.set_value(response.destinatary_id);
          }
          if (response.entity_id) {
            v.$refs.entity_dropdown.set_value(response.entity_id);
          }
          if (response.product_id) {
            v.$refs.product_dropdown.set_value(response.product_id);
          }
        })
        .catch((error) => {
          v.error = error_message(error);
        });
    },
    save() {
      let v = this;
      if (v.is_form_invalid) {
        v.error = "Por favor complete los campos requeridos";
        return;
      }

      v.error = "";
      let data = { ...v.meta };

      if (v.meta.uuid) {
        post("/account-request/personal-savings", data)
          .then(() => {
            success_message(
              v.$t("personal savings request updated successfully")
            );
            v.close_modal();
            v.$emit("success");
          })
          .catch((error) => {
            v.error = error;
          });
      } else {
        put("/account-request/personal-savings", data)
          .then(() => {
            success_message(
              v.$t("personal savings request created successfully")
            );
            v.close_modal();
            v.$emit("success");
          })
          .catch((error) => {
            v.error = error;
          });
      }
    },
    destinatary_changed(type) {
      if (type) {
        this.selected_destinatary = type;
        this.meta.destinatary_id = type.destinatary_id;
      }
    },
    entity_changed(type) {
      if (type) {
        this.selected_entity = type;
        this.meta.entity_id = type.entity_id;

        if (type.settings) {
          if (type.settings.default_send_email !== undefined)
            this.meta.settings.send_email = type.settings.default_send_email;
          if (type.settings.default_send_sms !== undefined)
            this.meta.settings.send_sms = type.settings.default_send_sms;
          if (type.settings.default_send_whatsapp !== undefined)
            this.meta.settings.send_whatsapp =
              type.settings.default_send_whatsapp;
          if (type.settings.default_run_onfido !== undefined)
            this.meta.settings.run_onfido = type.settings.default_run_onfido;
          if (type.settings.default_reproduce_video !== undefined)
            this.meta.settings.reproduce_video =
              type.settings.default_reproduce_video;
          if (type.settings.default_security_method !== undefined)
            this.meta.settings.security_method =
              type.settings.default_security_method;
          if (type.settings.default_flow !== undefined)
            this.meta.settings.flow = type.settings.default_flow;
        }
      }
    },
    add_destinatary() {
      this.$refs.destinatary_modal.show_modal();
    },
    product_changed(type) {
      if (type) {
        this.selected_product = type;
        this.meta.product_id = type.product_id;
        if (type.settings && type.settings.documentation) {
          this.meta.settings.documentation = type.settings.documentation.map(
            (doc) => {
              return { name: doc, is_required: true };
            }
          );
        } else {
          this.meta.settings.documentation = [];
        }
      }
    },
  },
};
</script>

<style scoped>
.modal-card {
  width: 600px;
  max-width: 90vw;
}
</style>
